import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-azure-modern',
  templateUrl: './azure-modern.component.html',
  styleUrls: ['./azure-modern.component.css']
})
export class AzureModernComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
